import { computed } from "@vue/composition-api";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { BaseMenuItem } from "@/types";

export const filterItems = computed<BaseMenuItem[]>(() => [
  {
    text: $t("All content"),
    name: "all",
    value: [
      ContentFeedTypeEnum.MEDIA,
      ...(config.featureEvents ? [ContentFeedTypeEnum.EVENT] : []),
      ...(config.featureTextPosts ? [ContentFeedTypeEnum.RICH_TEXT] : []),
    ],
  },
  {
    text: $t("Media posts"),
    name: "media",
    value: [ContentFeedTypeEnum.MEDIA],
  },
  ...(config.featureTextPosts
    ? [
        {
          text: $t("Text posts"),
          name: "text",
          value: [ContentFeedTypeEnum.RICH_TEXT],
        },
      ]
    : []),
  ...(config.featureEvents
    ? [
        {
          text: $t("Events"),
          name: "event",
          value: [ContentFeedTypeEnum.EVENT],
        },
      ]
    : []),
]);
